import { TenDLC } from './TenDLC';
const routes = {
    'w/:wallet_id/tendlc': {
        path: '/w/:wallet_id/tendlc',
        title: 'tendlc',
        component: TenDLC,
        auth: false,
    },
};
export default routes;
